import { render, staticRenderFns } from "./InvoicesView.vue?vue&type=template&id=64f77205&"
import script from "./InvoicesView.vue?vue&type=script&lang=js&"
export * from "./InvoicesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports